(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var itemsEl = document.getElementById('cart-page-items');
    if (!itemsEl) return;

    var subtotalEl = document.getElementById('cart-page-subtotal');
    var cartIcon = document.getElementById('cart-icon');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findItem(cart, key) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) return cart.items[i];
      }
      return null;
    }

    function updateRow(row, cart, key) {
      var item = findItem(cart, key);

      if (!item) {
        row.remove();
        if (cart.item_count === 0) location.reload();
        return;
      }

      row.querySelector('.cart-item__qty-count').textContent = item.quantity;
      row.querySelector('.cart-item__price').textContent = formatMoney(item.final_line_price);
    }

    function changeQuantity(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var row = itemsEl.querySelector('.cart-item[data-key="' + key + '"]');
          if (row) updateRow(row, cart, key);
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          if (cartIcon) cartIcon.src = cart.item_count > 0 ? cartIcon.dataset.fullSrc : cartIcon.dataset.emptySrc;
        });
    }

    itemsEl.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.cart-page-item__qty-btn');
      if (qtyBtn) {
        var key = qtyBtn.dataset.key;
        var delta = parseInt(qtyBtn.dataset.delta, 10);
        var countEl = qtyBtn.closest('.cart-item__qty').querySelector('.cart-item__qty-count');
        var next = parseInt(countEl.textContent, 10) + delta;
        if (next < 0) next = 0;
        changeQuantity(key, next);
        return;
      }

      var removeBtn = e.target.closest('.cart-page-item__remove');
      if (removeBtn) {
        changeQuantity(removeBtn.dataset.key, 0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var gallery = document.querySelector('[data-product-gallery]');
    if (gallery) {
      var thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
      var images = document.querySelectorAll('[data-gallery-image]');
      var track = document.querySelector('[data-gallery-track]');
      var activeIndex = 0;

      // The track only scrolls when it's the mobile carousel; on desktop
      // images are swapped by toggling product__image--hidden instead.
      function isCarousel() {
        return track && track.scrollWidth > track.clientWidth;
      }

      function selectImage(index, scrollTrack) {
        activeIndex = index;

        thumbnails.forEach(function (t, i) {
          var active = i === index;
          t.classList.toggle('product__thumbnail--active', active);
          if (active) {
            gallery.scrollTo({
              left: t.offsetLeft - (gallery.clientWidth - t.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }
        });

        images.forEach(function (image, i) {
          image.classList.toggle('product__image--hidden', i !== index);
        });

        if (scrollTrack && isCarousel()) {
          track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        }
      }

      thumbnails.forEach(function (thumbnail, index) {
        thumbnail.addEventListener('click', function () {
          selectImage(index, true);
        });
      });

      if (track) {
        var scrollFrame = null;
        track.addEventListener('scroll', function () {
          if (scrollFrame) return;
          scrollFrame = requestAnimationFrame(function () {
            scrollFrame = null;
            if (!isCarousel()) return;
            var index = Math.round(track.scrollLeft / track.clientWidth);
            if (index !== activeIndex) selectImage(index, false);
          });
        }, { passive: true });
      }

      // Secondary gallery images are hidden via display:none, so native
      // loading="lazy" can't reliably tell they're about to be shown. Warm
      // the browser cache for them ourselves once the page has settled.
      window.addEventListener('load', function () {
        images.forEach(function (image, index) {
          if (index === 0) return;

          var preload = new Image();
          if (image.sizes) preload.sizes = image.sizes;
          if (image.srcset) preload.srcset = image.srcset;
          preload.src = image.currentSrc || image.src;
        });
      });
    }

    var form = document.getElementById('product-form');
    if (!form) return;

    var priceEl = document.getElementById('product-price');
    var addBtn = form.querySelector('.product__add-to-cart');
    var addBtnLabel = form.querySelector('.product__add-to-cart-label');
    var addBtnPrice = form.querySelector('.product__add-to-cart-price');
    var pills = form.querySelectorAll('.product__pills input[type="radio"]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateProduct(price, available) {
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (addBtn) addBtn.disabled = !available;
      if (addBtnLabel) {
        addBtnLabel.textContent = available
          ? addBtn.dataset.labelAvailable
          : addBtn.dataset.labelSoldOut;
      }
      if (addBtnPrice) {
        addBtnPrice.hidden = !available;
        if (available) addBtnPrice.textContent = formatMoney(price);
      }
    }

    pills.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateProduct(
          parseInt(this.dataset.price, 10),
          this.dataset.available === 'true'
        );
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
